module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-1000.36c04587.svg";